var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "display": "inherit"
    },
    on: {
      "mouseover": function ($event) {
        return _vm.triggerTooltip(true);
      },
      "mouseleave": function ($event) {
        return _vm.triggerTooltip(false);
      }
    }
  }, [_vm._t("default"), _vm._v(" "), _c('Portal', {
    key: _vm.$vnode.key ? ("portal-" + (_vm.$vnode.key)) : null,
    attrs: {
      "to": "tooltip"
    }
  }, [_c('transition', {
    attrs: {
      "name": "scale-transition"
    }
  }, [_vm.isActive ? _c('div', {
    ref: "popup",
    style: _vm.popupStyle
  }, [_c('div', {
    staticClass: "tooltip whitespace-pre-line"
  }, [_vm._v(_vm._s(_vm.text))])]) : _vm._e()])], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }